<template>
    <div>
      <table-manager
        :options="table_manager_options"
        @ClickOnAddButton="showAdd"/>

      <basic-table
        v-if="notificationsTemplates"
        :items="notificationsTemplates"
        :fields="notificationsTemplatesFields"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        @ClickOnEditButton="editItem"
        @ClickOnDeleteButton="deleteItemButton"
        v-model="totalRows"
        isEdit="true"
        isDelete="true"/>

      <table-manager-bottom
        :totalRows="totalRows"
        :perPage="perPage"
        v-model="currentPage"/>

      <editModal :editItem="currentNotificationTemplateData" :eventVal="currentEvent" :event_options="currentEventsArr" />
    </div>
</template>

<script>
import TableManagerBottom from '@/components/tables/TableManagerBottom'
import editModal from './editModal'
export default {
  components: {
    TableManagerBottom,
    editModal
  },
  data () {
    return {
      notificationsTemplatesFields: [
        { key: 'id', label: this.$i18n.t('ID'), sortable: true },
        { key: 'subject_template', label: this.$i18n.t('Subject'), sortable: true },
        { key: 'message_template', label: this.$i18n.t('Message'), sortable: true },
        { key: 'recovery_time', label: this.$i18n.t('Recovery time'), sortable: true },
        { key: 'send_at_appointed_time',
          label: this.$i18n.t('Send at appointed time'),
          sortable: true,
          formatter: (val, key, item) => { return val ? this.$t('Yes') : this.$t('No') } },
        { key: 'event', label: this.$i18n.t('Event'), sortable: true },
        { key: 'group_id',
          label: this.$i18n.t('Group'),
          sortable: true,
          formatter: (val, key, item) => { return this.getGroupName(val) }
        },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ],
      filter: '',
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      isEdit: null,
      currentNotificationTemplateData: null,
      currentEvent: null,
      currentEventsArr: [],
      table_manager_options: {
        isShowAddButton: true
      }
    }
  },
  methods: {
    editItem (item) {
      this.currentEvent = item.event
      let tmp = {}
      tmp[item.event] = JSON.parse(JSON.stringify(item))
      tmp[item.event].settings = JSON.parse(item.settings)
      this.currentNotificationTemplateData = tmp
      this.currentEventsArr = [item.event]
      this.$root.$emit('bv::show::modal', 'modalEditNotificationsTemalate', '#btnShow')
    },
    deleteItemButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', 'Are you sure you want to delete one of "Notification Template?"', this.deleteItem, item)
    },
    deleteItem (item) {
      this.$store.dispatch('Users/DELETE_NOTIFICATION_TEMPLATE', item.id)
    },
    showAdd () {
      let templates = {}
      let eventList = []
      let arr = this.$store.getters['Users/NOTIFICATIONS_TEMPLATES_DEFAULT']

      for (let ind = 0; ind < arr.length; ++ind) {
        let el = arr[ind]
        templates[el.event] = JSON.parse(JSON.stringify(el))
        templates[el.event].settings = JSON.parse(el.settings)
        eventList.push(el.event)
      }
      this.currentNotificationTemplateData = templates
      this.currentEventsArr = eventList
      this.currentEvent = eventList[0]
      this.$root.$emit('bv::show::modal', 'modalEditNotificationsTemalate', '#btnShow')
    },
    getGroupName (id) {
      if (id === 0) {
        return '---'
      }
      for (let el of this.$store.getters['Users/GROUPS']) {
        if (el.group_id === id) {
          return el.group_name
        }
      }
      return '---'
    }
  },
  computed: {
    notificationsTemplates () {
      return this.$store.getters['Users/NOTIFICATIONS_TEMPLATES']
    }
  },
  watch: {
    notificationsTemplates: function (val) {
      this.totalRows = this.$store.getters['Users/NOTIFICATIONS_TEMPLATES_COUNT']
    }
  },
  mounted () {
    this.$store.dispatch('Users/GET_NOTIFICATIONS_TEMPLATES_DEFAULT')
    this.$store.dispatch('Users/GET_NOTIFICATIONS_TEMPLATES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/notificationsTemapltes/main.vue